import React from 'react';
import { number } from 'prop-types';

import { Row, Col, Pills } from '@ajaibid/components';
import { FORM_OPTIONS } from '@context/stock/buysell';

import { useStockBuySellContext } from '../../../hooks';

const InputBtnPercentage = (props) => {
  const { marginTop, marginBottom } = props;

  const { code, formState, formKey, formAction, dispatch } = useStockBuySellContext();

  return (
    <Row noGutters marginTop={marginTop} marginBottom={marginBottom}>
      <Col size={3} />
      <Col size={9}>
        <Row gutters={2} align="between">
          {FORM_OPTIONS.BTN_PERCENTAGE.map((v) => (
            <Col key={v.value}>
              <Pills
                fluid
                style={{ padding: '6px 8px' }}
                active={formState[formKey.BTN_PERCENTAGE] === v.value}
                onClick={() =>
                  dispatch({ type: formAction.CHANGE_BTN_PERCENTAGE, code, payload: v.value })
                }
                data-testid={`btn-percentage-${v.label}`}
              >
                {v.label}
              </Pills>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

InputBtnPercentage.propTypes = {
  marginTop: number,
  marginBottom: number,
};

InputBtnPercentage.defaultProps = {
  marginTop: 0,
  marginBottom: 0,
};

export default InputBtnPercentage;
